import React from "react";
import { Box } from "@mui/material";
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import BrandLogo from "../branding/BrandLogo";
import colors, { status } from "../../theme/colors";
import { APP_TOKENS } from "./publicFormTokens";

/**
 * Terminal state for a link that cannot be used.
 *
 * Rendered INSTEAD of the form. A revoked or expired link that still showed the
 * questions would waste the borrower's time and then fail at submit with a 410 —
 * after they had filled everything in.
 *
 * Deliberately gives no detail beyond the status: the person holding a dead link
 * is not necessarily the person it was issued to, so it names no borrower, no
 * loan, and no loan officer.
 */
const MESSAGES = {
  revoked: {
    title: "This link is no longer active",
    body: "It was cancelled by the team that sent it. Contact your loan officer for a new one.",
  },
  expired: {
    title: "This link has expired",
    body: "Application links are valid for 30 days. Contact your loan officer and they can send you a fresh one.",
  },
  consumed: {
    title: "This link has already been used",
    body: "The form it opens has been submitted. If you need to send something else, contact your loan officer.",
  },
  not_found: {
    title: "This link isn't valid",
    body: "The address may have been copied incompletely. Check the link in your email, or contact your loan officer.",
  },
};

const PublicLinkUnavailable = ({ status: linkStatus, hideLogo }) => {
  const copy = MESSAGES[linkStatus] || MESSAGES.not_found;

  return (
    <Box sx={{ backgroundColor: APP_TOKENS.canvas, minHeight: "100vh", py: 8 }}>
      <Flx column centerX gap={3} sx={{ px: 2 }}>
        {!hideLogo && <BrandLogo height={28} />}
        <Box
          sx={{
            width: "100%",
            maxWidth: 520,
            backgroundColor: APP_TOKENS.surface,
            border: `1px solid ${APP_TOKENS.border}`,
            borderRadius: "14px",
            boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
            p: { xs: 3, sm: 4.5 },
          }}
        >
          <Flx column centerX gap={2} sx={{ textAlign: "center" }}>
            <Flx
              centerX
              centerY
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                backgroundColor: status.warning.bg,
              }}
            >
              <ErrorOutlineRounded
                sx={{
                  fontSize: "24px !important",
                  color: `${status.warning.fg} !important`,
                }}
              />
            </Flx>
            <Txt
              component="h1"
              sx={{
                m: 0,
                fontSize: 20,
                fontWeight: 700,
                color: colors.slate900,
              }}
            >
              {copy.title}
            </Txt>
            <Txt
              component="div"
              sx={{ fontSize: 14.5, lineHeight: 1.6, color: colors.slate600 }}
            >
              {copy.body}
            </Txt>
          </Flx>
        </Box>
      </Flx>
    </Box>
  );
};

export default PublicLinkUnavailable;
